import React, { useState, useEffect } from 'react';
import LoaderController from '../Controllers/LoaderController.js';
import { RotatingLines } from 'react-loader-spinner';


export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    LoaderController._register(setIsLoading);
  }, []);

  return (
    <>
      {isLoading && (
        <div className="pointer-events-none fixed inset-0 bg-slate-500 bg-opacity-70 z-[9999] flex items-center justify-center">
        <RotatingLines
            visible={true}
            height="96"
            width="96"
            strokeColor="#f1f5f9"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
            />
        </div>
      )}
      {children}
    </>
  );
};
